<template>
  <div>
    <p v-if="added.positivePayout">
      Bei einem unveränderten Basiswertkurs kommt es zu einer
      Rückzahlung zum Nennbetrag von <span
      v-html="this.$options.filters.currency(product.specific.notional, 'EUR')"></span> zuzüglich einer
      Zahlung eines Kupons in Höhe von <span v-html="this.$options.filters.percent(product.figures.couponTotal)"></span>
      am <span v-html="this.$options.filters.date(product.common.payDate)"></span>.
    </p>

    <p v-if="!added.positivePayout && added.physical">
      Bei einem unveränderten Basiswertkurs erhält der Wertpapierinhaber am Ende der Laufzeit eine Lieferung von
      Aktien des Basiswertes. Die Anzahl der zu liefernden Aktien ergibt sich durch das Bezugsverhältnis. Bruchteile
      von Aktien werden in bar zurückgezahlt (Ausgleichszahlung). Zuzüglich erhält er eine
      Zahlung eines Kupons in Höhe von <span v-html="this.$options.filters.percent(product.figures.couponTotal)"></span>
      am <span v-html="this.$options.filters.date(product.common.payDate)"></span>.
    </p>

    <p v-if="!added.positivePayout && !added.physical">
      Bei einem unveränderten Basiswertkurs erfolgt eine Zahlung in Höhe des Marktpreises zuzüglich einer
      Zahlung eines Kupons in Höhe von <span v-html="this.$options.filters.percent(product.figures.couponTotal)"></span>
      am <span v-html="this.$options.filters.date(product.common.payDate)"></span>. In diesem Fall treten Verluste für
      das eingesetzte
      Kapital auf.
    </p>
  </div>
</template>

<script>
export default {
  name: 'payback-reverse',
  props: {
    product: {
      type: Object,
      required: true
    },
    added: {
      type: Object,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// PaybackReverse.vue?1c86c68b